export default "__VITE_ASSET__BjN1rApr__"